import PropTypes from 'prop-types';
// @mui
import { alpha, useTheme } from '@mui/material/styles';
// import Box from '@mui/material/Box';
// import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
// import Tooltip from '@mui/material/Tooltip';
// import Typography from '@mui/material/Typography';
// auth
import { useAuthContext } from 'src/auth/hooks';
// routes
import { paths } from 'src/routes/paths';
// import { RouterLink } from 'src/routes/components';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// theme
// import { bgGradient } from 'src/theme/css';
// components
// import Logo from 'src/components/logo';
// import img from '../../assets/Product/class.jpg'
// import video from "../../../public/video/login.mp4"
import "./main.css";
// ---------------------------------------------------------------

const METHODS = [
  {
    id: 'jwt',
    label: 'Jwt',
    path: paths.auth.jwt.login,
    icon: '/assets/icons/auth/ic_jwt.svg',
  },
  {
    id: 'firebase',
    label: 'Firebase',
    path: paths.auth.firebase.login,
    icon: '/assets/icons/auth/ic_firebase.svg',
  },
  {
    id: 'amplify',
    label: 'Amplify',
    path: paths.auth.amplify.login,
    icon: '/assets/icons/auth/ic_amplify.svg',
  },
  {
    id: 'auth0',
    label: 'Auth0',
    path: paths.auth.auth0.login,
    icon: '/assets/icons/auth/ic_auth0.svg',
  },
];

export default function AuthClassicLayout({ children, image, title }) {
  const { method } = useAuthContext();

  const theme = useTheme();

  const upMd = useResponsive('up', 'md');

  // const bgGradient = ({ color, imgUrl }) => ({
  //   backgroundSize: 'cover',
  //   backgroundPosition: 'center',
  // });

  const renderContent = (
    <Stack
      sx={{
        width: 1,
        mx: 'auto',
        maxWidth: 480,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        // alignItems:"center",
        px: { xs: 2, md: 8 },
        // py: { xs: 15, md: 30 },
      }}
    >
      {children}
    </Stack>
  );

  const renderSection = (
    <Stack
      flexGrow={2}
      alignItems="center"
      justifyContent="center"
      spacing={10}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        height: "100vh",
        background: 'linear-gradient(180deg, rgba(21, 21, 28, 0) 0%, rgba(21, 21, 28, 0.1) 40%, rgba(21, 21, 28, 0.3) 55%, rgba(21, 21, 28, 0.61) 75%, #15151c)',
        // ...bgGradient({
        //   color: alpha(
        //     theme.palette.background.default,
        //     theme.palette.mode === 'light' ? 0.88 : 0.94
        //   ),
        //   imgUrl: '', // This can be omitted if you only want the video
        // }),
      }}
    >
      <video
        src='https://api.siteprogress.ae/login_page_video/login.mp4'
        autoPlay
        loop
        muted
        style={{
          position: "absolute",
          width: "135%",
          height: '100vh',
          objectFit: 'fill',
          zIndex: -1,
        }}
      />
    </Stack>

  );

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        // minHeight: '100vh',
        // overflow: "hidden"
      }}
    >
      {/* <Box p={2}>
      <img style={{height:80}} alt='logo' src='/logo/logo.png' />
      </Box> */}

      {upMd && renderSection}

      {renderContent}
    </Stack>
  );
}

AuthClassicLayout.propTypes = {
  children: PropTypes.node,
  image: PropTypes.string,
  title: PropTypes.string,
};
